import styled, { css } from 'styled-components';
import { DEVICES } from '_constants';

export const DropdownsBlock = styled.div`
  display: flex;
  align-items: center;

  > div {
    margin: 0 0 0 24px;
  }
`;

export const PaginationBlock = styled.div`
  display: flex;
  align-items: center;

  > div {
    margin: 0 0 0 24px;
    display: flex;
    button {
      padding: 1px 6px;
    }
  }
`;

const WrapperDropdown = styled.div.attrs(() => ({
  ariaRequired: true,
}))`
  margin-bottom: 27px;
  ${({ isRow }) =>
    isRow &&
    css`
      display: flex;
      align-items: center;
    `};

  @media ${DEVICES.tablet} {
    width: 100%;
    margin-bottom: 15px;
    ${({ isMerger }) =>
      isMerger &&
      css`
        margin-bottom: 10px;
      `}
  }

  @media ${DEVICES.mobileL} {
    width: 100%;
    margin-bottom: 5px;
  }
`;

export const Wrapper = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-right: 1px solid var(--rgb-grey);
  border-bottom: 1px solid var(--rgb-grey);
  border-left: 1px solid var(--rgb-grey);
  box-sizing: border-box;
  padding: 10px 15px;

  ${({ isStoreMerger }) =>
    isStoreMerger &&
    css`
      padding: 0;
      border: none;
    `}

  ${WrapperDropdown} {
    margin-bottom: 0;
  }

  /**
   * New design: the rows-per-page and page selects are rounded like every other field in the app.
   *
   * Declared here, on the pagination itself, rather than in a table's footer wrapper -- that only
   * reaches paginations rendered INSIDE a card (ui-kit/DataTable's Footer, Mergers' TableFooter),
   * and the ones drawn standalone below a table kept the square default. One definition covers
   * both.
   */
  html[data-new-ui='true'] & {
    .BaseSelect__control {
      min-height: 34px;
      border-radius: 8px;
      border-color: var(--grey);
      box-shadow: none;

      &:hover {
        border-color: var(--forest);
      }
    }

    .BaseSelect__menu {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  @media ${DEVICES.laptop} {
    flex-direction: column;
    height: auto;

    ${PaginationBlock} {
      order: -1;
    }

    ${DropdownsBlock} {
      margin: 10px 0 0;
    }

    ${PaginationBlock},
    ${DropdownsBlock} {
      justify-content: space-between;
      width: 100%;

      > div {
        margin: 0;
      }
      button {
        padding 1px 6px;
      }
    }
  }

  @media ${DEVICES.tablet} {
    padding: 10px 5px;
  }
`;

export const DropdownsWrapper = styled.div`
  position: relative;
`;
